
















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import CardsDeck from './CardsDeck.vue';
import GamesStats from './GamesStats.vue';
import PlayersOnline from './PlayersOnline.vue';
import GitHubIconSVG from './github-icon.svg';

@Component({
  components: {
    CardsDeck,
    GamesStats,
    PlayersOnline,
    GitHubIconSVG,
  },
  props: {
    gamesPlayed: Array,
    isCardsRevealed: Boolean,
    messages: Array,
    newGame: Function,
    playCard: Function,
    player: Object,
    showCards: Function,
  },
})
export default class PokerTable extends Vue {
  @Prop({ default: [] })
  private playersOnline!: any[];

  private showSidebar: boolean = false;

  private ToggleSidebar(): void {
    this.showSidebar = !this.showSidebar;
  }

  private get players() {
    return this.playersOnline.reduce((object, value) => {
      const newObjet = { ...object, ...{ [value.connectionId]: value } };
      return newObjet;
    }, {});
  }
}
